import React from 'react';
import { motion } from 'framer-motion';
import './BackToTop.css';

const BackToTop = ({ onClick }) => {
  return (
    <motion.button
      className="back-to-top"
      onClick={onClick}
      whileHover={{ 
        scale: 1.1,
        y: -3,
        transition: { duration: 0.3 }
      }}
      whileTap={{ scale: 0.9 }}
    >
      <i className="fas fa-arrow-up"></i>
    </motion.button>
  );
};

export default BackToTop;


